import DOMPurify from "dompurify";

/**
 * XSS対策のサニタイズ処理
 * @see https://github.com/cure53/DOMPurify
 *
 * @param dirty
 * @returns
 */
export const sanitize = (dirty: string | Node): string => {
	return DOMPurify.sanitize(dirty);
};
